<template>
	<div>

		<t-text-area
			height="500px"
			resize="none"
			:value="messageContents"
		/>

	</div>
</template>

<script>

import { mapGetters } from './store/outbound.store';
export default {
	
	name: 'OriginalMessage',

	props: { base64Content: String },
	computed: {
		...mapGetters(['getTransmissionDetails']),
		messageContents() {
			if (!this.getTransmissionDetails.originalMessage)
				return '';
			return JSON.stringify(this.getTransmissionDetails.originalMessage, null, 2);
		}
		
		
	}
	
	
};
</script>

<style>

</style>